import { createTheme } from '@fluentui/react';
import { SharedColors } from '@uifabric/fluent-theme/lib/fluent/FluentColors';
import { Depths } from '@uifabric/fluent-theme/lib/fluent/FluentDepths';
import { DefaultThemeColors, NeutralColors } from './CoherenceColors';
var CoherenceColorPalette;
(function (CoherenceColorPalette) {
    CoherenceColorPalette.black = NeutralColors.gray200;
    CoherenceColorPalette.neutralDark = NeutralColors.gray200;
    CoherenceColorPalette.neutralPrimary = NeutralColors.gray200;
    CoherenceColorPalette.neutralPrimaryAlt = NeutralColors.gray90;
    CoherenceColorPalette.neutralSecondary = NeutralColors.gray130;
    CoherenceColorPalette.neutralSecondaryAlt = NeutralColors.gray80;
    CoherenceColorPalette.neutralTertiary = NeutralColors.gray70;
    CoherenceColorPalette.neutralTertiaryAlt = NeutralColors.gray60;
    CoherenceColorPalette.neutralQuaternary = NeutralColors.gray50;
    CoherenceColorPalette.neutralQuaternaryAlt = NeutralColors.gray40;
    CoherenceColorPalette.neutralLight = NeutralColors.gray30;
    CoherenceColorPalette.neutralLighter = NeutralColors.gray20;
    CoherenceColorPalette.neutralLighterAlt = NeutralColors.gray10;
    CoherenceColorPalette.white = NeutralColors.white;
    CoherenceColorPalette.themeDarker = DefaultThemeColors.blue100;
    CoherenceColorPalette.themeDark = DefaultThemeColors.blue80;
    CoherenceColorPalette.themeDarkAlt = DefaultThemeColors.blue90;
    CoherenceColorPalette.themePrimary = DefaultThemeColors.blue70;
    CoherenceColorPalette.themeSecondary = DefaultThemeColors.blue60;
    CoherenceColorPalette.themeTertiary = DefaultThemeColors.blue50;
    CoherenceColorPalette.themeLight = DefaultThemeColors.blue30;
    CoherenceColorPalette.themeLighter = DefaultThemeColors.blue20;
    CoherenceColorPalette.themeLighterAlt = DefaultThemeColors.blue10;
    CoherenceColorPalette.red = SharedColors.red10;
    CoherenceColorPalette.redDark = SharedColors.red20;
})(CoherenceColorPalette || (CoherenceColorPalette = {}));
var p = CoherenceColorPalette;
var extendedSemanticColors = {
    headerText: p.neutralPrimary,
    navBackground: p.neutralQuaternaryAlt,
    navItemBackgroundHovered: p.neutralQuaternary,
    navItemBackgroundPressed: p.neutralTertiaryAlt,
    bodyStandoutBackground: p.neutralLighter,
    bodyTextChecked: p.neutralLighter,
    disabledBodyText: p.neutralTertiaryAlt,
    variantBorder: p.neutralSecondary,
    variantBorderHovered: p.neutralSecondary,
    defaultStateBackground: p.white,
    link: p.themeDark,
    linkHovered: p.themeDarker,
    buttonBackgroundChecked: p.neutralLight,
    buttonBackgroundCheckedHovered: p.neutralQuaternary,
    buttonBorder: p.neutralSecondary,
    buttonTextHovered: p.neutralPrimary,
    buttonTextChecked: p.neutralPrimary,
    buttonTextCheckedHovered: p.neutralPrimary,
    buttonTextPressed: p.neutralPrimary,
    buttonTextDisabled: p.neutralTertiaryAlt,
    primaryButtonTextDisabled: p.neutralTertiaryAlt,
    accentButtonBackground: p.themePrimary,
    inputBorder: p.neutralSecondary,
    inputFocusBorderAlt: p.themeDarkAlt,
    inputTextHovered: p.neutralPrimary,
    disabledText: p.neutralTertiaryAlt,
    disabledSubtext: p.neutralTertiaryAlt,
    listItemBackgroundCheckedHovered: p.neutralQuaternary,
    menuDivider: p.neutralQuaternaryAlt,
    menuIcon: p.neutralPrimary,
    menuHeader: p.neutralPrimary,
    menuItemTextHovered: p.neutralPrimary
};
export var CoherenceTheme = createTheme({
    palette: {
        black: p.black,
        neutralDark: p.neutralDark,
        neutralPrimary: p.neutralPrimary,
        neutralPrimaryAlt: p.neutralPrimaryAlt,
        neutralSecondary: p.neutralSecondary,
        neutralSecondaryAlt: p.neutralSecondaryAlt,
        neutralTertiary: p.neutralTertiary,
        neutralTertiaryAlt: p.neutralTertiaryAlt,
        neutralQuaternary: p.neutralQuaternary,
        neutralQuaternaryAlt: p.neutralQuaternaryAlt,
        neutralLight: p.neutralLight,
        neutralLighter: p.neutralLighter,
        neutralLighterAlt: p.neutralLighterAlt,
        themeDarker: p.themeDarker,
        themeDark: p.themeDark,
        themeDarkAlt: p.themeDarkAlt,
        themePrimary: p.themePrimary,
        themeSecondary: p.themeSecondary,
        themeTertiary: p.themeTertiary,
        themeLight: p.themeLight,
        themeLighter: p.themeLighter,
        themeLighterAlt: p.themeLighterAlt,
        white: p.white,
        red: p.red,
        redDark: p.redDark
    },
    semanticColors: extendedSemanticColors,
    effects: {
        roundedCorner2: '2px',
        elevation4: Depths.depth4,
        elevation8: Depths.depth8,
        elevation16: Depths.depth16,
        elevation64: Depths.depth64
    }
});
export default CoherenceTheme;
//# sourceMappingURL=CoherenceTheme.js.map